<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/y0Lc4t/media/FC-9781645364306.jpg?1684515798306" alt="This image is the cover for the book Modern-Day Palmistry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Modern-Day Palmistry
      </h1>
      <p class="bookDescription body article font2">
        <p>Palmistry can tell you many things about yourself, others, and the world around you. Discover: - if you will marry - how many kids will you have - what kind of person would suit you as a partner - your career path - what kind of work would give you the most satisfaction - how to get the most happiness and success out of your life. All of this and more inside of Modern-Day Palmistry!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susie Polzin
      </h2>
      
      <p class="authorDescription body article">Susie Polzin has been doing palmistry for almost forty years and has condensed her findings into this easy-to-read guide so that people may use it as a tool to help themselves and others, and to understand how it may enhance their lives to better their chances at happiness and success.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2838ccf0